import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';

//Layouts
import NonAuthLayout from '../Layouts/NonAuthLayout';
import VerticalLayout from '../Layouts/index';

//routes
import { authProtectedRoutes, publicRoutes } from './allRoutes';
import { crudeProtectedRoutes } from './allroutecrude';
import { AuthProtected } from './AuthProtected';
import ProtectedRoute from './ProtectedRoute';

const mergedProtectedRoutes = [...authProtectedRoutes, ...crudeProtectedRoutes];
const AuthLayoutShell = () => (
  <AuthProtected>
    <Outlet />
  </AuthProtected>
);

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              // `layout: 'none'` dipakai route yang memasang layoutnya sendiri
              // (mis. landing publik). Tanpa properti itu perilakunya tidak
              // berubah: tetap NonAuthLayout, termasuk untuk /login.
              element={
                route.layout === 'none' ? (
                  route.component
                ) : (
                  <NonAuthLayout>{route.component}</NonAuthLayout>
                )
              }
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route element={<AuthLayoutShell />}>
          {mergedProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <ProtectedRoute>
                  <VerticalLayout>{route.component}</VerticalLayout>
                </ProtectedRoute>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
